import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Zap, Calendar, BadgeCheck, GraduationCap } from 'lucide-react';

const benefits = [
  {
    icon: Zap,
    title: 'Rapid Contingency Staffing',
    description:
      'Quickly deploy qualified healthcare professionals to fill urgent gaps during emergencies or high-demand periods.',
  },
  {
    icon: Calendar,
    title: 'Long-Term Workforce Planning',
    description:
      'Strategically build a stable and sustainable workforce tailored to your facility\'s future staffing needs.',
  },
  {
    icon: BadgeCheck,
    title: 'Credentialed Healthcare Professionals',
    description:
      'Access a vetted pool of licensed and credentialed clinicians ready to deliver high-quality patient care.',
  },
  {
    icon: GraduationCap,
    title: 'Client-Specific Orientation Programs',
    description:
      'Ensure smooth onboarding with customized training aligned to your workflows, systems, and facility protocols.',
  },
];

export const WhyChooseUs = () => {
  const [titleRef, titleVisible] = useScrollAnimation();
  const [cardsRef, cardsVisible] = useScrollAnimation();

  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="section-padding bg-white"
    >
      <div className="container-width">
        {/* Section Header */}
        <div
          ref={titleRef}
          className={`text-center mb-16 animate-on-scroll ${titleVisible ? 'visible' : ''}`}
        >
          <span className="inline-block text-sm font-medium tracking-widest uppercase text-primary/60 mb-4">
            Why Choose Us
          </span>
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-primary">
            Staffing That Keeps Your Facility Running at Full Capacity
          </h2>
        </div>

        {/* Benefits Grid */}
        <div
          ref={cardsRef}
          className={`grid md:grid-cols-2 gap-8 stagger-children ${
            cardsVisible ? 'visible' : ''
          }`}
        >
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="benefit-card group"
              data-testid={`benefit-card-${index}`}
            >
              <div className="flex items-start gap-6">
                <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300 flex-shrink-0">
                  <benefit.icon className="h-7 w-7" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-primary mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
